window.selectInit = function() {
	function setCurrency (currency) {
		if (!currency.id) { return currency.text; }
		let $currency = $('<span>' + currency.text + '</span>' + '<span class="text-number">' + $(currency.element).data('count') + '</span>');
		return $currency;
	};

	$('.js-select2Single').each(function(){
		$(this).select2({
			theme: 'default form-select2',
			minimumResultsForSearch: 100000,
			placeholder:  $(this).data('placeholder'),
			width: '100%',
			language: {
				noResults: function(){
					return $(this).data('noresult-title');
				}
			},
		});		
	});

	$('.js-select2SingleTemplating').each((index, element) => {
		$(element).select2({
			placeholder: $(element).data('placeholder'),
			templateResult: setCurrency,
			templateSelection: setCurrency,
			width: '100%',
			theme: 'default form-select2',
			language: {
				noResults: function(){
					return $(this).data('noresult-title');
				}
			},
		});
	});
}

$(window).on('load', function() {
	selectInit();

	if ($('.form-select').length > 0) {
		$('.form-select').addClass('show')
	}
})
